var map = {
	"./tonghua.png": "3a04",
	"./tonghua0.png": "58dd",
	"./tonghua1.png": "86896",
	"./tonghua2.png": "2d3b4",
	"./tonghua3.png": "e26b",
	"./tonghua4.png": "32ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "373d";